import { ApplicationConfig, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideEnvironmentNgxMask } from 'ngx-mask'
import { correlationInterceptor } from './http-interceptors/correlation.interceptor';
import { provideNativeDateAdapter } from '@angular/material/core';
import { ApmErrorHandler, ApmModule, ApmService } from '@elastic/apm-rum-angular'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes), 
    provideHttpClient(
      withInterceptors([correlationInterceptor])
    ),
    provideEnvironmentNgxMask(),
    provideNativeDateAdapter(),
    importProvidersFrom(ApmModule, ApmService),
    { provide: ErrorHandler, useClass: ApmErrorHandler }
  ],
};
